import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import RouteAvatar from 'components/route-manager/RouteDetailsModal/RouteAvatar/RouteAvatar'
import { isValidHex } from 'utils/validations'

import type { NotificationFact } from './useNotificationFacts'

const chipSx = { maxWidth: 220 }

// A route with no colour set is stored as black, hence the ring separating the disc from the surface.
const avatarSx = { width: 20, height: 20, border: '1px solid', borderColor: 'divider' }

// The Typography's own themed colour beats what the avatar passes down, so contrast is set on the text.
const avatarTextProps = (contrastText: string) => ({ variant: 'caption', fontWeight: 700, color: contrastText })

const NotificationFacts = ({ facts }: { facts: NotificationFact[] }) => {
  const theme = useTheme()
  if (facts.length === 0) return null

  return (
    <Stack useFlexGap direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', rowGap: 0.5 }}>
      {facts.map(fact => {
        const swatch = fact.swatch && isValidHex(fact.swatch) ? fact.swatch : null
        return (
          <Chip
            key={fact.key}
            color={fact.isAccent ? 'primary' : 'default'}
            icon={fact.icon}
            label={fact.label}
            size="small"
            sx={chipSx}
            variant="outlined"
            {...(swatch && {
              avatar: (
                <RouteAvatar
                  avatarSrc=""
                  bgcolor={swatch}
                  name={fact.label}
                  sx={avatarSx}
                  TypographyProps={avatarTextProps(theme.palette.getContrastText(swatch))}
                />
              ),
            })}
          />
        )
      })}
    </Stack>
  )
}

export default NotificationFacts
